import { render, staticRenderFns } from "./CurrentHealthProblems.vue?vue&type=template&id=3498f1b8&scoped=true"
import script from "./CurrentHealthProblems.vue?vue&type=script&lang=js"
export * from "./CurrentHealthProblems.vue?vue&type=script&lang=js"
import style0 from "./CurrentHealthProblems.vue?vue&type=style&index=0&id=3498f1b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3498f1b8",
  null
  
)

export default component.exports